var $ = require('jQuery');

/**
 * Copier Class
 *
 * Note: Since copy is a common action, this class is generic and loads the submission URL and METHOD from
 *  the button directly to aid re-use.
 *  For custom single-use Markers, this information can be defined directly in the class.
 */
module.exports = function(marker) {
    var parent = this;
    var marker = marker;

    // Get the Marker instance
    this.getMarker = function() {
        return marker;
    };

    // Handle Copy button click.
    this.copyClicked = function() {
        var form = $("#marker-action-copy");

        parent.getMarker().addIdsToForm(form);

        if(parent.getMarker().idsExist()) {
            form.submit();
        } else {
            parent.getMarker().displayError();
        }
    };

    // jQuery Bindings
    $("#marker-action-copy .marker-action-button").on("click", this.copyClicked);
};
